// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取相关oss配置 GET /oss/config-info */
export async function ossConfigInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.ossConfigInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultOssConfigInfoResp>('/oss/config-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 生成预签名url GET /oss/generate-presign-url */
export async function ossGeneratePresignUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.ossGeneratePresignUrlUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultURL>('/oss/generate-presign-url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
